/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2023 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import{getBitcoinDataFilter as t,getBitcoinKeypair as e,getEthereumDataFilter as a,getEthereumKeypair as r,getX509DataFilter as o,getX509Keypair as i}from"./dynamic.js";import{unexpectedData as n,unsupportedData as s}from"./shared/errors.js";import{KeyType as c,keyTypeFromString as p}from"./shared/types.js";export const generateKey=async(t,a)=>{switch(t){case c.bitcoin:{const t=await e();return await t.generateRandom(a)}case c.ethereum:{const t=await r();return await t.generateRandom()}case c.x509:}throw s("key type")};export const generateCompatibleKey=t=>{const e=t.getType(),a=t.getLocalType();return generateKey(e,a)};export const getBaseTypeFromFullType=t=>{const e=t.split(":")[0];return p(e)};export const importKey=async(p,m)=>{switch(p){case c.bitcoin:{const a=await e();if(!(await t())(m))throw n("ImportData");return await a.import(m)}case c.ethereum:{const t=await r();if(!(await a())(m))throw n("ImportData");return await t.import(m)}case c.x509:{const t=await i();if(!(await o())(m))throw n("ImportData");return await t.import(m)}}throw s("key type")};